import React from "react";
import { useAppSelector } from "store/hooks";
import { getColorTheme } from "store/slices/userSessionSlice";
import logoColorSrc from "assets/images/HNC_color.png";
import logoWhiteSrc from "assets/images/HNC_white_nocaption.png";

/**
 * Returns logo for current theme
 * @returns Hustlencode logo
 */
export default function Logo() {
  const theme = useAppSelector(getColorTheme);
  if (theme === "light") {
    return <img src={logoColorSrc} alt="logo" />;
  }

  return <img src={logoWhiteSrc} alt="logo" />;
}
